import {connect, useSelector} from 'react-redux'
import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
  Children,
} from "react";
import { createPortal } from "react-dom";
import config from "../../config";
import _ from "lodash";
import debounce from "lodash.debounce";
import session from "../../utils/session"
// import tailwindStyles from "!raw-loader!../../tailwind.generated.css"; // Load the compiled Tailwind CSS as a string
import { initRoom, leaveRoom, syncCompanyRoom } from '../../io.js';
import { deleteContact } from '../../reducers/contact/resources';
import { updateNotification } from '../../reducers/notification/actions';
import { getUserSettings } from '../../reducers/integrations/resources';
import { ReloadOutlined } from "@ant-design/icons";

import {
  CalendarFilled,
  LaptopOutlined,
  NotificationOutlined,
  PaperClipOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import { Badge, Card, Empty, Mentions, MenuProps, Popover, SegmentedProps, Select } from "antd";
import {
  ConfigProvider,
  Breadcrumb,
  Input,
  Layout,
  Menu,
  theme,
  Flex,
  Splitter,
  TreeSelect,
  Tooltip,
  Typography,
  Col,
  Row,
  Radio,
  Segmented,
  Button,
  Dropdown,
  message,
  Space,
  Modal,
} from "antd";

import {useInboxV2Styles} from './inboxv2-styles';
import { InboxErrorBoundary } from './components/ErrorBoundary';

import { CheckboxGroupProps } from "antd/es/checkbox";
const { TextArea } = Input;

import {
  AppstoreOutlined,
  BellOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  ContactsOutlined,
  FilterOutlined,
  MailOutlined,
  SendOutlined,
  MessageOutlined,
  SettingOutlined,
  InboxOutlined,
  TagsOutlined,
  StarOutlined,
  TeamOutlined,
  ContainerOutlined,
} from "@ant-design/icons";
import MessageList from "./components/MessageList/MessageList";
import BulkActionBar from "./components/MessageList/BulkActionBar/BulkActionBar";
import TagsComponent from "./components/Tags/tags";
import ScrollableLoadMore from "./components/ScrollableLoadMore";
import ThreadList from "./components/Threads/ThreadList";
import MessageInputField from "./components/MessageInputField/MessageInputField";
import { TileAvatar } from "./components/helpers/ui";
import InboxFilterSettings from "./components/InboxFilterSettings";

import { useStore } from './inbox-store'
import FullPageLoader from './components/FullPageLoader/FullPageLoader';
import { MenuItemType } from 'antd/es/menu/interface';
import ActiveContactHeader from './components/ActiveContactHeader/ActiveContactHeader';
import PageTourButton from '../guide/PageTourButton';
import { getInboxSteps } from '../guide/toursteps';

const { Header, Content, Sider, Footer } = Layout;
const { Text, Title } = Typography;

const { SHOW_PARENT } = TreeSelect;


type MenuItem = Required<MenuProps>["items"][number];


/**dropdown */





const onMessageInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) => {
  console.log("Change:", e.target.value);
};

/** end dropdown */

const InboxV2 = ({ selectedCompany, selectedCompanyData, initRoom, latestNotifications, unreadCount, updateNotification })=> {

  const [hasScheduling, setHasScheduling] = useState(false);
  const {contentStyle, headerStyle, layoutStyle, PanelStyle, textingInputAreaStyle} = useInboxV2Styles({ hasScheduling });
  const subFilterOptions: SegmentedProps<string>["options"] = [
    { label: "All", value: "all", className: "noBootstrapLabel" },
    { label: "Inbox", value: "inbox", className: "noBootstrapLabel" },
    { label: "Sent", value: "sent", className: "noBootstrapLabel" },
  ];

  const onFiltersChange = (newValue: string[]) => {
    console.log("onChange ", newValue);
    setFilterValue(newValue);
    if(newValue.length > 0) {
      localStorage.setItem(`gohire_inbox_filters_${companyId}`, JSON.stringify(newValue));
    } else {
       // if cleared, maybe we remove or keep empty? user logic below sets it to allContacts if empty
       // so we will handle that in the next lines
    }
    
    if(newValue.length===0)
      { //none selected on UI, then restore to default
        setFilterValue(['allContacts'])
        return;
      }
  
      clearConversations()
      clearThreads()
      setActiveContact('')
      const textingNumbers = _.filter(filters,{type:'bot',channel:'sms'})
      const webchat = _.filter(filters,{type:'bot',channel:'webchat'})
      const locations = _.filter(filters,{type:'location'})
      
      const textingNumberItems =  _.map(textingNumbers,(item)=>{return {type:'bot',id:item.botmap_id}});
      const webchatItems = _.map(webchat,(item)=>{return {type:'bot',id:item.botmap_id}});
      const locationItems = _.map(locations,(item)=>{return {type:'location',id:item.location_id}});
  
      const getQueryItem = (id)=>{
          return _.find([...textingNumberItems,...webchatItems,...locationItems],{id})
      }
  
      const filterQueries: Array<{type: string; id: string} | {type: string; id: string}[]> = _.map(newValue,(filterOption)=>{
        let filterItems: {type: string; id: string}[] = []
        switch(filterOption){
          case 'allContacts': filterItems = [...textingNumberItems,...webchatItems,...locationItems]; break;
          case 'allTextingNumbers': filterItems = [...textingNumberItems]; break;
          case 'allWebChat': filterItems = [...webchatItems]; break;
          case 'allLocations': filterItems = [...locationItems]; break;
          default: 
            const item = getQueryItem(filterOption);
            filterItems = item ? [item] : [];
            break; 
        }
        return filterItems
      })

      //add current top-level filter
      const [topLevelFilter] = selectedMenuOption;
      if(topLevelFilter.includes('campaign-')){
        filterQueries.push({
          type:'campaign',
          id:topLevelFilter.substring(9)
        })
      }else if(topLevelFilter.includes('tag-')){
        filterQueries.push({
          type:'tag',
          id:topLevelFilter.substring(4)
        })
      }else if(topLevelFilter.includes('group-')){
        filterQueries.push({
          type:'group',
          id:topLevelFilter.substring(6)
        })
      }else{
        filterQueries.push({
          type:'top',
          id:topLevelFilter
        })
      }
      
      //add sub-filter
      filterQueries.push({
        type:'subfilter',
        id:subFilter
      })

  
      const filterQuery = _.flatten(filterQueries).filter(Boolean);
  
      setConversationFilters(filterQuery)
  };

/***** */


 const [spinning, setSpinning] = React.useState(true);
 const [selectedMenuOption ,setSelectedMenuOption] = React.useState(["inbox"])
 const [conversationFilters,setConversationFilters] = React.useState<any[] | null>(null)
 const [companyId,setCompanyId]= React.useState(selectedCompany || session.get('userData').companyId)
 const [subFilter,setSubFilter] = React.useState('all')
 const [settingsLoaded, setSettingsLoaded] = useState(false);


  const retrieveFilters = useStore((state) => state.retrieveFilters)
  const retrieveCampaigns = useStore((state) => state.retrieveCampaigns)
  const retrieveTags = useStore((state) => state.retrieveTags)
  const retrieveGroups = useStore((state) => state.retrieveGroups)
  const retrieveConversations = useStore((state)=>state.retrieveConversations)
  const clearConversations= useStore((state)=>state.clearConversations)
  const setActiveContact = useStore((state)=>state.setActiveContact)
  const retrieveContactThreads =useStore((state)=>state.retrieveContactThreads)
  const retrieveUserMessageTemplates = useStore((state)=>state.retrieveUserMessageTemplates)
  const retrieveSequenceTemplates = useStore((state)=>state.retrieveSequenceTemplates)
  const removeConversation = useStore((state)=>state.removeConversation)

  const prevSelectedCompany = useRef()
  const clearThreads = useStore((state)=>state.clearThreads)
  const threads = useStore((state)=>state.threads)
  const filters = useStore((state)=>state.filters)
  const campaigns = useStore((state)=>state.campaigns)
  const tags = useStore((state)=>state.tags)
  const groups = useStore((state)=>state.groups)
  const conversations = useStore((state)=>state.conversations)
  const bulkSelectedCount = useStore((state)=>state.selectedContacts.size)
  const activeContact = useStore((state)=>state.activeContact)
  const activeContactModel = useStore((state)=>state.activeContactModel)

  /**filter states */
  type TreeNode = {
    title: React.ReactNode; // Allows JSX
    value: string;
    key?: string; // Optional, but can be useful
    children?: TreeNode[];
  };

  const [filterOptions,setFilterOptions]=useState<TreeNode[]>(
    [
      {
        title: 'All Contacts',
        value: 'allContacts',
        children: [
          { title: <strong>'Child Node 1'</strong>, value: 'child1' },
        ],
      },
    ]
  )
  const [showSubFilters,setShowSubFilters]=useState(false)
  const [filterValue, setFilterValue] = useState(() => {
    try {
      const currentCompanyId = selectedCompany || session.get('userData').companyId;
      const savedFilters = localStorage.getItem(`gohire_inbox_filters_${currentCompanyId}`);
      if (savedFilters) {
          const parsed = JSON.parse(savedFilters);
          if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      }
    } catch (e) {
      console.error("Error loading filters from localStorage", e);
    }
    return ["allContacts"];
  });
  const [defaultUserFilters, setDefaultUserFilters] = useState<string[] | null>(null);

  const handleResetFilters = () => {
    const defaults = defaultUserFilters || ['allContacts'];
    setFilterValue(defaults);
    onFiltersChange(defaults);
  };


  
const handleMenuClick: MenuProps["onClick"] = (a) => {
  setShowSubFilters(
    ![
      "inbox",
      "sent",
      "starred",
      "archive",
    ].includes(a.key)
  );
  setSelectedMenuOption([a.key]);
};


/**end filter states */
/*** campaign states */

const [campaignOptions,setCampaignOptions]=useState<MenuItemType[]>([]);

/*** end campaign states */

/*** tag states */

const [tagOptions,setTagOptions]=useState<MenuItemType[]>([]);

/*** end tag states */

/*** group states */
const [groupOptions,setGroupOptions]=useState<MenuItemType[]>([]);
/*** end group states */

  const deleteContactAsync = async (contactId) => {
    try {
      await deleteContact(contactId);
      message.success('Contact deleted successfully');
      setActiveContact('');
      removeConversation(contactId);
      clearConversations();
      retrieveConversations(companyId, conversationFilters || [], 1, 15);
    } catch (error) {
      message.error('Failed to delete contact');
    }
  };


  // Update redux notification store when active contact changes (marking notifications as read).
  //
  // Skip the first invocation on mount: Zustand persists `activeContact` across
  // route navigation, so re-mounting /inbox with the previously-selected contact
  // would otherwise silently mark any notifications that arrived while away as
  // read — without the user actually opening the contact. We only want this
  // effect to fire on user-driven transitions inside the inbox session.
  const didMarkAsReadMount = useRef(false);
  useEffect(() => {
    if (!didMarkAsReadMount.current) {
      didMarkAsReadMount.current = true;
      return;
    }
    if (activeContact) {
      // Find the conversation and check if it had unread notifications (before it was marked as read)
      const conversation = conversations.find(c => c.contact_id === activeContact);
      // If there were unread notifications, update the redux store
      if (conversation && latestNotifications && latestNotifications.length > 0) {
        // Mark notifications for this contact as read instead of filtering them out
        const updatedNotifications = latestNotifications.map(n =>
          n.contact_id === activeContact ? { ...n, is_read: true } : n
        );
        // Calculate the new unread count
        const newUnreadCount = updatedNotifications.filter(n => !n.is_read).length;
        const hasChanges = latestNotifications.some(
          n => n.contact_id === activeContact && !n.is_read
        );
        if (hasChanges) {
          updateNotification({
            latestNotifications: updatedNotifications,
            unreadCount: newUnreadCount
          });
        }
      }
    }
  }, [activeContact]);


useEffect(() => {

    if(prevSelectedCompany.current){
      leaveRoom(prevSelectedCompany.current)
    }

    const userData = session.get('userData') || {};
    const companyId = selectedCompany || userData.companyId;

    initRoom(companyId)
    // Join userId room so receiveMsg events (inbound messages) reach this client
    if (userData.id) initRoom(userData.id)

    setCompanyId(companyId)
    
    // Reset state
    setSubFilter('all');
    setActiveContact('');
    setConversationFilters(null);
    clearThreads();
    setSpinning(true);
    setSettingsLoaded(false);

    const APIcalls = async () => {
      setShowSubFilters(false);
      const userData = session.get('userData') || {};
      const userId = userData.id;

      // The socket connects before login, so the company room can't be joined
      // at connect time. Join it here (and on company switch) so company-wide
      // tag/group/star fan-outs reach the list views, not just the open contact.
      syncCompanyRoom(companyId);

      try {
        const [settingsRes] = await Promise.all([
            userId ? getUserSettings(userId).catch(() => ({ data: {} })) : Promise.resolve({ data: {} }),
            retrieveFilters(companyId),
            retrieveTags(companyId),
            retrieveCampaigns(companyId),
            retrieveGroups(companyId),
            retrieveUserMessageTemplates(),
            retrieveSequenceTemplates()
        ]);

        // 1. Determine Server-Side Defaults
        const settings = settingsRes.data || {};
        let userDefaults: string[] = [];
        
        if (settings.defaultInboxFilters) {
            if (Array.isArray(settings.defaultInboxFilters)) {
                userDefaults = settings.defaultInboxFilters.map((f: any) => f.id);
            } else if (settings.defaultInboxFilters[companyId]) {
                 // In InboxFilterSettings we save {type, id}. TreeSelect values are just IDs (except 'all...').
                userDefaults = settings.defaultInboxFilters[companyId].map((f: any) => f.id);
            }
        }

        if (!userDefaults || userDefaults.length === 0) {
            userDefaults = ['allContacts'];
        }

        // 2. Determine Initial Filters (LocalStorage > Server Defaults)
        const savedFilters = localStorage.getItem(`gohire_inbox_filters_${companyId}`);
        let initialFilters = [...userDefaults]; // Copy defaults as baseline

        if (savedFilters) {
             try {
                 const parsed = JSON.parse(savedFilters);
                 if (Array.isArray(parsed) && parsed.length > 0) {
                     initialFilters = parsed;
                 }
             } catch (e) {}
        }
        
        setFilterValue(initialFilters);
        setDefaultUserFilters(userDefaults.map(String));
        
      } catch (e) {
          console.error(e);
      } finally {
          setSelectedMenuOption(['inbox']);
          setSpinning(false);
          setSettingsLoaded(true);
          console.log("done");
      }
    };

    APIcalls();


  }, [selectedCompany]);

  useEffect(()=>{
    
    const textingNumbers = _.filter(filters,{type:'bot',channel:'sms'})
    const webchat = _.filter(filters,{type:'bot',channel:'webchat'})
    const locations = _.filter(filters,{type:'location'})
   
    const treeData:TreeNode = 
      {
        title: "All Contacts",
        value: "allContacts",
        children:[]
      }
    

    if(textingNumbers.length){
      const menu = {
        title: "All Texting Numbers",
            value: "allTextingNumbers",
            children: _.map(textingNumbers,(data,i)=>{
              return {
                title: (
                  <Tooltip 
                  placement='right'
                  title={
                    `${data.label.sublabel}`
                  }>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{data.label.label}</Text>
                  
                  </div>
                  </Tooltip>
                ),
                value: data.botmap_id,
              }
            })
        }
        treeData.children.push(menu)
    }

    if(webchat.length){
      const menu = {
        title: "All Web Chat",
            value: "allWebChat",
            children: _.map(webchat,(data,i)=>{
              return {
                title: (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{data.label}</Text>
                  </div>
                ),
                value: data.botmap_id,
              }
            })
        }
        treeData.children.push(menu)
    }

    if(locations.length){
      const menu = {
        title: "All Locations",
            value: "allLocations",
            children: _.map(locations,(data,i)=>{
              return {
                title: (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{data.label}</Text>
                  </div>
                ),
                value: data.location_id,
              }
            })
        }
        
        treeData.children.push(menu)
    }
    
    setFilterOptions([treeData])


    
    // Only apply filters if settings have been loaded (meaning filterValue is authoritative)
    if (settingsLoaded && filterValue && filterValue.length > 0) {
         onFiltersChange(filterValue);
    }

  },[filters, settingsLoaded])

  useEffect(()=>{
    const menu = _.map(campaigns,(campaign,i)=>{
      return {key:`campaign-${campaign.id}`,value:campaign.id,label:<Tooltip title={campaign.name} placement='right'>{campaign.name}</Tooltip>}
    })

    setCampaignOptions(menu)

  },[campaigns])

  useEffect(()=>{
    const menu = _.map(tags,(tag,i)=>{
      return {key:`tag-${tag.value}`, value:tag.value,label:<Tooltip title={tag.value} placement='right'>{tag.value}</Tooltip>}
    })

    setTagOptions(menu)
  },[tags])

  useEffect(()=>{
    const menu = _.map(groups,(group,i)=>{
      return {key:`group-${group.id}`, value:group.id,label:<Tooltip title={group.name} placement='right'>{group.name}</Tooltip>}
    })
    setGroupOptions(menu)
  },[groups])


  useEffect(()=>{
    //console.log('selectedMenu',selectedMenuOption)

    // Guard against premature execution before settings are loaded
    if (!settingsLoaded || !filterValue) return;

    setSubFilter('all')
    
    if(activeContact && activeContact.length){
      leaveRoom(activeContact)
    }

    setActiveContact('')
    onFiltersChange(filterValue)
  },[selectedMenuOption, settingsLoaded])


  useEffect(()=>{
   // console.log("subfilter updated",subFilter)
   
    // Guard against premature execution before settings are loaded
    if (!settingsLoaded || !filterValue) return;

    if(activeContact && activeContact.length){
      leaveRoom(activeContact)
    }
    setActiveContact('')
    onFiltersChange(filterValue)
  },[subFilter, settingsLoaded])


 
  const items: MenuItem[] = [
    {
      key: "inbox",
      label: "Inbox",
      icon: <InboxOutlined />,
    },
    {
      key: "sent",
      label: "Sent",
      icon: <SendOutlined />,
    },
    {
      key: "starred",
      label: "Starred",
      icon: <StarOutlined />,
    },
    {
      // Per-user Archive (ADR-034): conversations this user set aside. They
      // return to Inbox automatically when the candidate sends a message.
      key: "archive",
      label: "Archive",
      icon: <ContainerOutlined />,
    },
    {
      type: "divider",
    },
    {
      key: "sub5",
      label: "Tags",
      icon: <TagsOutlined />,
      children: tagOptions
    },
    {
      key: "sub6",
      label: "Groups",
      icon: <TeamOutlined />,
      children: groupOptions,
    },
    {
      key: "sub4",
      label: "Campaigns",
      icon: <NotificationOutlined />,
      children: campaignOptions,
    },
  ];



/***** */








   const handleSettingsSaved = (newFilters: string[]) => {
      setDefaultUserFilters(newFilters);
      setFilterValue(newFilters);
      onFiltersChange(newFilters);
  };
    
  return (
    <ConfigProvider
      theme={{
        components: {
          Splitter: {
            splitBarDraggableSize: 20,
            splitBarSize: 2,
            splitTriggerSize: 2,
          },
        },
      }}
    >
      <Flex
        gap="middle"
        vertical
        style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 54px)" }}
      >
        <Layout style={layoutStyle}>
          <Splitter>
            {/** first panel */}
            <Splitter.Panel defaultSize="20%" min="20%" max="20%">
              <Layout style={layoutStyle}>
                <Header style={{...headerStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 3, padding: '0 3px'}}>
                
                   <InboxFilterSettings  
                       disabled={showSubFilters} 
                       filters={filters} 
                       companyId={companyId}
                       onSave={handleSettingsSaved} 
                   />

                    <TreeSelect
                      disabled={showSubFilters || !settingsLoaded}
                      treeData={filterOptions}
                      value={settingsLoaded ? filterValue : []}
                      onChange={onFiltersChange}
                      treeCheckable={true}
                      showCheckedStrategy={SHOW_PARENT}
                      treeDefaultExpandedKeys={["allContacts"]}
                      placeholder={settingsLoaded ? "Please select" : "Loading…"}
                      style={{
                        flex: 1,
                      }}
                      maxTagCount={1}
                      suffixIcon={
                        !_.isEqual(_.sortBy(filterValue), _.sortBy(defaultUserFilters || ['allContacts'])) ? (
                          <Tooltip title="Reset Filters">
                            <ReloadOutlined 
                              style={{ color: '#888', fontWeight: 600, cursor: 'pointer' }} 
                              onClick={(e) => {
                                e.stopPropagation();
                                handleResetFilters();
                              }} 
                            />
                          </Tooltip>
                        ) : (
                          <FilterOutlined />
                        )
                      }
                    />
                 
                </Header>
                <Content style={contentStyle}>
                  <Menu
                    className="inboxSideMenu"
                    onClick={handleMenuClick}
                    style={{
                      minWidth: 0,
                      width: "100%",
                      flex: "auto",
                      borderRight: "none",
                    }}
                    defaultSelectedKeys={["inbox"]}
                    defaultOpenKeys={["sub4", "sub5", "sub6"]}
                    mode="inline"
                    items={items}
                    selectedKeys={selectedMenuOption}
                  />
                </Content>
              </Layout>
            </Splitter.Panel>
            {/** second panel */}
            <Splitter.Panel defaultSize="35%" min="35%" max="50%" className="tour-inbox-conversations">
              <Layout style={layoutStyle}>
                <Header style={{ ...headerStyle, padding: "3px 10px", display: 'flex', alignItems: 'center' }}>
                  <Row justify="space-around" align="middle" style={{ width: '100%' }}>
                    {/* While rows are bulk-selected the action bar takes the
                        whole header and the sub-filter Segmented hides. */}
                    <Col
                      span={showSubFilters && bulkSelectedCount === 0 ? 8 : 24}
                      style={showSubFilters && bulkSelectedCount === 0 ? {} : { paddingRight: 0 }}
                    >
                      <BulkActionBar conversations={conversations}>
                        <Title ellipsis level={5} style={{ margin: 0 }}>Conversations <PageTourButton steps={getInboxSteps()} /></Title>
                      </BulkActionBar>
                    </Col>
                    {showSubFilters && bulkSelectedCount === 0 && (
                      <Col span={16}>
                        <Segmented options={subFilterOptions} value={subFilter} onChange={setSubFilter} size="small" block style={{color: 'gray'}} />
                      </Col>
                    )}
                  </Row>
                </Header>
                {/* <Content style={contentStyle}> */}
                <MessageList
                  companyId={companyId}
                  filters={conversationFilters}
                  conversations={conversations}
                  retrieveConversations={retrieveConversations}
                />
                {/* </Content> */}
              </Layout>
            </Splitter.Panel>
            {/** third panel */}
            <Splitter.Panel defaultSize="45%" min="45%" max="50%">
              <Layout style={layoutStyle}>
                <div
                  style={{
                    ...headerStyle,
                    padding: "0px 10px",
                  }}
                >
                  <ActiveContactHeader onDeleteContact={deleteContactAsync} />
                </div>
                <Content style={{...PanelStyle,background:'#fafafa', flex: 1}}>
                    {!activeContact || !activeContactModel || !activeContactModel.id ? 
                    <Space direction='vertical' align='center' style={{ width: "100%", height: "100%", justifyContent: "center" }}>
                        <Empty description="Select a conversation to view messages." style={{ height: "100%" }}/>
                    </Space>
                  
                    :
                    <ThreadList contactId={activeContactModel.id} threads={threads} retrieveThreads={retrieveContactThreads} contact={activeContactModel} />
                    }
                  </Content>
                <Footer style={textingInputAreaStyle} className="tour-inbox-reply">
                  <MessageInputField onSchedulingChange={setHasScheduling} />
                </Footer>
              </Layout>
            </Splitter.Panel>
          </Splitter>
        </Layout>
        <FullPageLoader isSpinning={spinning} />
      </Flex>
    </ConfigProvider>
  );
}






const mapStateToProps = (state) => {
  const {
    company: { selectedCompany, selectedCompanyData },
    notification: { latestNotifications = [], unreadCount = 0 } = {},
  } = state
  return { selectedCompany, selectedCompanyData, latestNotifications, unreadCount }
}
const mapDispatchToProps = (dispatch) => {
  return {
    initRoom(id) {
      return initRoom(id)
    },
    updateNotification(data) {
      return dispatch(updateNotification(data))
    },
  }
}

// Connect InboxV2 to Redux
const ConnectedInboxV2 = connect(mapStateToProps, mapDispatchToProps)(InboxV2);

// Wrap with error boundary for graceful error handling
const InboxV2WithErrorBoundary = (props) => (
  <InboxErrorBoundary>
    <ConnectedInboxV2 {...props} />
  </InboxErrorBoundary>
);

export default InboxV2WithErrorBoundary;